// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
// Auth
import { AuthGuard } from './core/auth';
import { TermsConditionsComponent } from './views/pages/auth/terms-conditions/terms-conditions.component';

const routes: Routes = [
  { path: 'terms-conditions', component: TermsConditionsComponent },
  { path: 'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule) },
  { path: 'error', loadChildren: () => import('./views/pages/error/error.module').then(m => m.ErrorModule) },
  { path: 'survey', loadChildren: () => import('./views/pages/customer-survey/customer-survey.module').then(m => m.SurveydModule) },
  {
    path: 'qntCalculation',
    loadChildren: () => import('./views/pages/qnt-calculation/qnt-calculation.routing.module').then(m => m.QntCalculationModule)
  },
  { path: 'confirmation', loadChildren: () => import('./views/pages/confirmation/confirmation.module').then(m => m.ConfirmationModule) },
  { path: 'resetPassword', loadChildren: () => import('./views/pages/reset-password/resetPassword.module').then(m => m.ResetPasswordModule) },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'drawing',
        loadChildren: () => import('./views/pages/drawing/drawing.module').then(m => m.DrawingdModule),
      },
      {
        path: 'masterentity',
        loadChildren: () => import('./views/pages/master-entity/master-entity.module').then(m => m.MasterEntityModule),
      },
      {
        path: 'projects',
        loadChildren: () => import('./views/pages/project/project.module').then(m => m.ProjectdModule),
      },
      {
        path: 'customers',
        loadChildren: () => import('./views/pages/customer/customer.module').then(m => m.CustomerModule),
      },
      {
        path: 'prebuildview',
        loadChildren: () => import('./views/pages/PreBuildView/PreBuildView.module').then((m) => m.PreBuildViewModule),
      },
      {
        path: 'mail',
        loadChildren: () => import('./views/pages/apps/mail/mail.module').then(m => m.MailModule),
      },
      {
        path: 'ecommerce',
        loadChildren: () => import('./views/pages/apps/e-commerce/e-commerce.module').then(m => m.ECommerceModule),
      },
      {
        path: 'ngbootstrap',
        loadChildren: () => import('./views/pages/ngbootstrap/ngbootstrap.module').then(m => m.NgbootstrapModule),
      },
      {

        path: 'material',
        loadChildren: () => import('./views/pages/material/material.module').then(m => m.MaterialModule),
      },
      {
        path: 'user-management',
        loadChildren: () => import('./views/pages/user-management/user-management.module').then(m => m.UserManagementModule),
      },
      {
        path: 'wizard',
        loadChildren: () => import('./views/pages/wizard/wizard.module').then(m => m.WizardModule),
      },
      {
        path: 'builder',
        loadChildren: () => import('./views/theme/content/builder/builder.module').then(m => m.BuilderModule),
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: '**', redirectTo: 'projects', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'error/403', pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
